export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14245.052b9b61.jpg";